import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DailyAttendance } from '@/components/transport/attendance/DailyAttendance';
import { MonthlyAttendance } from '@/components/transport/attendance/MonthlyAttendance';

const Attendance = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FFFBF5]" data-testid="transport-attendance-page">
      <header className="bg-[#1A1F2E] text-[#F9FAFB] shadow-lg">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center gap-4">
          <Button variant="ghost" onClick={() => navigate('/sections/transport')} className="text-[#F9FAFB] hover:bg-white/10" data-testid="back-button"><ArrowLeft className="w-5 h-5" /></Button>
          <h1 className="text-xl font-bold font-display">Driver Attendance</h1>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 md:px-6 py-6">
        <Tabs defaultValue="daily" className="space-y-4">
          <TabsList>
            <TabsTrigger value="daily" data-testid="attendance-tab-daily">Daily</TabsTrigger>
            <TabsTrigger value="monthly" data-testid="attendance-tab-monthly">Monthly</TabsTrigger>
          </TabsList>
          <TabsContent value="daily"><DailyAttendance /></TabsContent>
          <TabsContent value="monthly"><MonthlyAttendance /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default Attendance;
